/** PURE_IMPORTS_START .._.._Observable,.._.._operator_window PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { window } from '../../operator/window';
Observable.prototype.window = window;
//# sourceMappingURL=window.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/window.js
// module id = ./node_modules/rxjs/_esm5/add/operator/window.js
// module chunks = vendor